import { StringSchema } from "../../common/classes/schema";
import { TranslationKey } from "../../common/functions/translate";

const emailSchema = new StringSchema()
    .required('enter_your_new_email_address')
    .betweenLength(6, 63, 'the_email_length_is_invalid')
    // This regex is copied from SLS, so don't change it without verifying it's also changed in SLS
    .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+[.][a-z]+$/i, 'the_email_is_invalid')

export const validateEmail = (email: string) => {
    return emailSchema.validate(email);
}

export const validatePhone = (phone: string, phoneType: 'sms' | 'voice') => {
    const badPhoneNumbers = [
        '0000000000',
        '1111111111',
        '2222222222',
        '3333333333',
        '4444444444',
        '5555555555',
        '6666666666',
        '7777777777',
        '8888888888',
        '9999999999',
        '1234567890',
        '0123456789'
    ];
    const empty = `enter_your_phone_number_${phoneType}` as const;
    const invalidNumberErrorMessage: TranslationKey = `invalid_phone_number_${phoneType}`;

    const digitsAllowed = /^\d+$/;
    const phoneSchema = new StringSchema()
        .required(empty)
        .min(10, invalidNumberErrorMessage)
        .matches(digitsAllowed, invalidNumberErrorMessage)
        .max(10, invalidNumberErrorMessage)
        .test('invalid phone number', invalidNumberErrorMessage, () => {
            if (badPhoneNumbers.includes(phone)) {
                return false;
            }
            return true;
        });
    return phoneSchema.validate(phone);
}

const otpSchema = new StringSchema()
    .required('enter_the_six_digit_code')
    .matches(/^\d{6}$/, 'invalid_code')

export const validateOtp = (otp: string) => {
    return otpSchema.validate(otp);
}